module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comp-no-data"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-box"
  }, [_vm._t("default", [_vm._v("暂无数据")])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-box"
  }, [_c('i', {
    staticClass: "icon-record"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7efda64e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7efda64e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/NoData.vue
// module id = 45
// module chunks = 1